export default {
  doctor: {},
};
